var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { API } from "./_base";
import { getSettings } from "../constants/setting";
import { MESSAGE_TYPE_CATEGORY, MESSAGE_TYPE_TEXT } from "../constants";
var getBotSetting = function (language) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, API().authenticated.get('/chatbot/' + getSettings().bot_id + '/settings?language=' + language.toLowerCase() + '&current_page_url=' + window.location.href)];
            case 1:
                response = _b.sent();
                return [4 /*yield*/, response];
            case 2: return [2 /*return*/, _b.sent()];
        }
    });
}); };
var postSendMessage = function (sessionId, text, currentPageUrl) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, API().authenticated.post('/chatbot/' + getSettings().bot_id + '/messages', {
                    type: MESSAGE_TYPE_TEXT,
                    session_id: sessionId,
                    language: getSettings().language,
                    text: text,
                    current_page_url: currentPageUrl
                })];
            case 1:
                response = _b.sent();
                return [4 /*yield*/, response];
            case 2: return [2 /*return*/, _b.sent()];
        }
    });
}); };
var startSession = function (data) {
    if (data === void 0) { data = {}; }
    return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, API().authenticated.post('/chatbot/' + getSettings().bot_id + '/sessions', __assign({ language: getSettings().language }, data))];
                case 1:
                    response = _b.sent();
                    return [4 /*yield*/, response];
                case 2: return [2 /*return*/, _b.sent()];
            }
        });
    });
};
var fetchQuestions = function (sessionId, category) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, API().authenticated.post('/chatbot/' + getSettings().bot_id + '/messages', {
                    type: MESSAGE_TYPE_CATEGORY,
                    session_id: sessionId,
                    language: getSettings().language,
                    text: category
                })];
            case 1:
                response = _b.sent();
                return [4 /*yield*/, response];
            case 2: return [2 /*return*/, _b.sent()];
        }
    });
}); };
var logVisitedSearchResult = function (sessionId, title, link, bot_item_id) {
    var path = '/chatbot/' + getSettings().bot_id + '/log-visited-search-result';
    var data = {
        session_id: sessionId,
        title: title,
        link: link,
        bot_item_id: bot_item_id
    };
    if (typeof window.fetch == 'function') {
        var blob = new Blob([JSON.stringify(data)], {
            type: 'application/json',
        });
        fetch(getSettings().api_url + path, {
            keepalive: true,
            method: 'POST',
            body: blob,
            credentials: 'omit'
        });
    }
    else {
        API().authenticated.post(path, data).catch(function (err) { return console.error(err); });
    }
};
var sendContactUsForm = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, API().authenticated.post('/chatbot/' + getSettings().bot_id + '/contact-us', data)];
            case 1:
                response = _b.sent();
                return [4 /*yield*/, response];
            case 2: return [2 /*return*/, _b.sent()];
        }
    });
}); };
var searchDistrictSite = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, API().authenticated.post('/chatbot/' + getSettings().bot_id + '/search-district-website', __assign(__assign({}, data), { language: getSettings().language }))];
            case 1:
                response = _b.sent();
                return [4 /*yield*/, response];
            case 2: return [2 /*return*/, _b.sent()];
        }
    });
}); };
var addAnswerFeedback = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, API().authenticated.post('/chatbot/' + getSettings().bot_id + '/answer-feedback', data)];
            case 1:
                response = _b.sent();
                return [4 /*yield*/, response];
            case 2: return [2 /*return*/, _b.sent()];
        }
    });
}); };
export default { postSendMessage: postSendMessage, getBotSetting: getBotSetting, startSession: startSession, fetchQuestions: fetchQuestions, logVisitedSearchResult: logVisitedSearchResult, sendContactUsForm: sendContactUsForm, searchDistrictSite: searchDistrictSite, addAnswerFeedback: addAnswerFeedback };
